export default "__VITE_ASSET__C7g$H4PS__"